import { canFilter } from '../../mixins/can_filter';
import { canPaginate } from '../../mixins/can_paginate';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider
    .when('/activation_codes', {
        template: require('./activation_codes.html'),
        controller: 'ActivationCodesController',
        controllerAs: '$ctrl'
    });
})
.controller('ActivationCodesController', function(ActivationCodes, toaster, $routeParams, $scope, $location, $route) {
    'ngInject';

    // BoxCast API standard filtration/pagination
    canFilter($scope, $location);
    canPaginate($scope, $location);

    // Hoist scope
    const self = this;

    let params = _.pick($scope, 'q', 's', 'p');
    this.loading = true;

    ActivationCodes.list(params, (res, getResponseHeader) => {
        const pagination = getResponseHeader('X-Pagination');
        $scope.pagination = (pagination ? JSON.parse(pagination) : {});
        res.forEach((code) => code.row_expanded = false);
        this.codes = res;
    }, (err) => {
        toaster.pop({
            type: 'error',
            body: `Whoops, we weren't able to list the activation codes.`,
            timeout: 2000
        });
    });

    this.copyToClipboard = (e, value) => {
        let selBox = document.createElement('textarea');
        selBox.value = value;
        e.target.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy')
        e.target.removeChild(selBox)
    }

    this.statuses = [
        { label: 'Created', value: 'created' },
        { label: 'Distributed', value: 'distributed' },
        { label: 'Activated', value: 'activated' },
    ];

    this.resellers = [
        { label: 'None', value: '' },
        { label: 'B & H', value: 'bh' },
        { label: 'Adorama', value: 'adorama' },
        { label: 'DVE Store', value: 'dve_store' },
        { label: 'Tie Photo', value: 'tie_photo' }
    ];

    this.distributors = [
        { label: 'BoxCast Inventory', value: 'boxcast' },
        { label: '1SourceVideo', value: '1sv' }
    ];

    // Values must align with stripe plan names
    this.stripePlans = [
        { label: 'BoxCast Essential Plan (1-Year Live Streaming Subscription)', value: 'essential:annual' },
        { label: 'BoxCast Live (1-Year Live Streaming Subscription)', value: 'partner:live:12mo:annual' },
        { label: 'BoxCast Standard (1-Year Live Streaming Subscription)', value: 'partner:standard:12mo:annual' },
        { label: 'BoxCast Advanced (1-Year Live Streaming Subscription)', value: 'partner:advanced:12mo:annual' },
        { label: 'BoxCast Advanced Plus (1-Year Live Streaming Subscription)', value: 'partner:advanced_plus:12mo:annual' },
        { label: 'BoxCast RTMP Encoder Activation', value: 'partner:addon:rtmp:annual' },
        { label: 'Feature: Multi-site Player', value: 'addon:multisite:annual' },
        { label: 'Feature: Password Protection', value: 'addon:password:annual' },
        { label: 'Feature: Graphic Overlays', value: 'partner:addon:overlays:annual' },
        { label: 'Feature: Additional Simulcast Broadcast', value: 'partner:addon:simultaneous:annual' },
        { label: 'Feature: GeoBlocking', value: 'partner:addon:geoblocking:annual' },
        { label: 'Feature: Ticketing', value: 'partner:addon:ticketing:annual' },
        { label: 'Feature: Pro Bundle', value: 'addon:pro-bundle:annual:600' },
        { label: 'Feature: Experience Bundle', value: 'addon:experiencebundle:annual:1200' },
    ];

    // Form for generating codes defaults
    this.stripe_plan = this.stripePlans[0].value;
    this.num_codes = 1;

    this.onGenerateClick = () => {
        if(this.num_codes === undefined) {
            toaster.pop({
                type: 'error',
                body: `Whoops, you can only generate 10 codes at a time.`,
                timeout: 3000
            });

            return;
        }

        ActivationCodes.create({
            'stripe_plan' : this.stripe_plan,
            'num_codes'   : this.num_codes
        }).$promise.then((res) => {
            $route.reload();
        });
    };

    // Expand/collapse individual codes for more info
    this.toggleRow = (code) => {
        if (!code.row_expanded) {
            this.loadActivationCode(code);
        } else {
            code.row_expanded = false;
        }
    };

    // Fetch data for expanded row
    this.loadActivationCode = (code) => {
        code.row_loading = true;
        ActivationCodes.get({ id: code.code }).$promise.then((res) => {
            code.row_loading = false;
            code.row_expanded = true;
            code.details = res;
        });
    };

    // Edit existing code
    this.edit = (code, idx) => {
        this.editing = idx;
        this.editCode = angular.copy(code);

        this.editCode.reseller = this.resellers.find((item) => item.value === code.reseller).value;
        this.editCode.distributor = this.distributors.find((item) => item.value === code.distributor).value;
        this.editCode.status = this.statuses.find((item) => item.value === code.status).value;
    };

    // Save existing code
    this.save = (code) => {
        ActivationCodes.update({
            'reseller'   : this.editCode.reseller,
            'status'     : this.editCode.status,
            'distributor': this.editCode.distributor,
            'id'         : this.editCode.code
        }).$promise.then((res) => {
            // Update the view's table row fields without refreshing/hitting api
            code.details = this.editCode;
            code.status = this.editCode.status;

            this.editCode = null;
            self.editing = false;
        });
    };

    // Cancel editing of existing quote
    this.cancel = () => {
        this.editCode = null;
        this.editing = false;
    };
});



// WEBPACK FOOTER //
// ./views/activation_codes/activation_codes_controller.js